module.exports = require("stream");